<template>
  <div class="detail-books">
      <div class="detail-books__head display-flex-center justify-content-between">
            <router-link to="/thu-vien" class="secondary-color-txt font-size-15 font-family-Semibold">
                <i class="icon-close secondary-color-txt"></i>
                Thoát
            </router-link>
            <h3 class="font-size-15 secondary-color-txt font-sanpro-semibold">Toán 1 - Bài 1: Các số 0, 1, 2, 3, 4, 5</h3>
            <div class="btn-function">
                <button class="btn-prepare primary-color color_bg_gray_light font-size-15 font-sanpro-semibold">Soạn bài giảng</button>
                <button class="btn-show primary-bg-color color-light font-size-15 font-sanpro-semibold position-rel"><i class="icon-next font-size-20 color-light"></i> Trình chiếu</button>
            </div>
      </div>
      <div class="detail-books__body">
          <div class="container text-center">
              <img src="@/assets/imgs/img-detail.png" alt="">
          </div>
      </div>
      <div class="detail-books__footer color_bg_gray_light display-flex-center justify-content-between position-rel">
            <a href="javascript:;" class="primary-color font-size-16 font-sanpro-semibold book-viewer__footer__cats border-rd-20 position-rel display-flex-center justify-content-center">
              <!-- <i class="icon-category font-size-22"></i> -->
              <img src="@/assets/imgs/icon-list.png" class="icon-list" alt="">
              <span class="only-pc">Danh sách</span>
            </a>
            <div class="book-viewer__paging display-flex-center">
                    <button class="d-none d-lg-block disabled">
                        <i class="icon-first-page color-light"></i>
                    </button>
                    <button class="disabled">
                        <i class="icon-prev color-light"></i>
                    </button>
                <div class="book-viewer__paging__input">
                    <input type="number" style="display: none;">
                    <span class="show-pages text-center">0</span>
                    <span class="show-pages show-pages--mobile">1</span>
                </div>
                <button class="">
                    <i class="icon-next color-light"></i>
                </button>
                <button class="d-none d-lg-block">
                    <i class="icon-last-page color-light"></i>
                </button>
            </div>
            <div class="book-viewer__zoom__mobile d-lg-none">
                <div class="wrap display-flex-center">
                    <!---->
                    <div class="book-viewer__zoom__mobile__icon">
                        <i class="icon-more primary-color"></i>
                    </div>
                </div>
            </div>
            <div class="book-viewer__zoom-switch display-flex-center only-pc">
                <!---->
                <div class="book-viewer__zoom">
                    <button class="zoom-out">
                        <i class="icon-minus font-size-14 secondary-color-txt"></i>
                    </button>
                    <span data-v-07540c38="">100 %</span>
                    <button class="zoom-in">
                        <i class="icon-plus font-size-14 secondary-color-txt"></i>
                    </button>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    name: "ViewDetailBooks"
}
</script>

<style lang="scss" scoped>
  // Variables
@import "./../../../assets/scss/variables";
    .detail-books{
        &__head{
            height: 55px;
            border-bottom: 1px solid $color_border_line;
            padding: 0 35px;
            .btn-function{
                .btn-prepare{
                    width: 140px;
                    margin-right: 18px;
                    &:hover{
                        opacity: .8;
                    }
                }
                .btn-show{
                    width: 135px;
                    i{
                        position: absolute;
                        left: 7px;
                        top: 5px;
                    }
                    &:hover{
                        color: $primary_color;
                        background: #fff;
                        border: 1px solid $primary_color;
                        i{
                            color: $primary_color;
                        }
                    }
                }
                button{
                    height: 30px;
                    line-height: 30px;
                    border: 0;
                    border-radius: 20px;
                }
            }
        }
        &__body{
            margin: 40px 0;
        }
        &__footer{
            height: 70px;
            border-top: 1px solid $color_border_line;
            padding: 0 35px;
            z-index: 12;
            .icon-list{
                height: 15px;
                width: 15px;
                margin-right: 5px;
            }
            .book-viewer__footer__cats{
                margin-right: 7px;
                height: 30px;
                min-width: 140px;
                line-height: 28px;
                i{
                    margin-right: 8px;
                }
            }
            .book-viewer__zoom{
                width: 115px;
                overflow: hidden;
                margin-right: 18px;
                button.zoom-out,
                button.zoom-in{
                margin-left: 5px;
            }
            .switch-viewpage{
                width: 70px;
                height: 30px;
                    input{
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    cursor: pointer;
                    z-index: 2;
                }
            }
            .switch-viewpage input:checked ~ .bg-transition{
                transform: translateX(40px);
                -webkit-transform: translateX(40px);
            }
            .switch-viewpage {
                label{
                    cursor: pointer;
                    z-index: 1;
                }
                .bg-transition, .switch-viewpage label{
                    width: 30px;
                    height: 30px;
                }
            }
        }
    }
    }
    @media (min-width: 992px){
        .d-lg-none {
            display: none !important;
        }
    }
    

</style>